import { LoadingButton, Select, SelectItem, TextField, Typography } from "@firecms/ui";
import { type FormEvent } from "react";

import { PROMO_CODE_TYPE_OPTIONS } from "../../PromoCodesCreate.constants";
import { type PromoCodesCreateFormType } from "../../PromoCodesCreate.types";
import { type PromoCodesCreateFormProps } from "./PromoCodesCreateForm.types";

const PromoCodesCreateForm: React.FC<PromoCodesCreateFormProps> = ({
  formValues,
  fieldErrors,
  rootError,
  loading,
  onFieldChange,
  onSubmit,
}) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <Typography variant="h4">Neue Promo Codes erstellen</Typography>

      {rootError ? (
        <Typography variant="body1" className="text-red-600">
          {rootError}
        </Typography>
      ) : null}

      <TextField
        label="Anzahl der Codes"
        name="amountCodes"
        type="number"
        value={formValues.amountCodes}
        onChange={(event) => {
          onFieldChange("amountCodes", Number(event.target.value));
        }}
        error={Boolean(fieldErrors.amountCodes)}
        required
        min={1}
        max={1000}
      />
      {fieldErrors.amountCodes ? (
        <Typography variant="caption" color="error">
          {fieldErrors.amountCodes}
        </Typography>
      ) : null}

      <TextField
        label="Gültig bis"
        name="expiresOn"
        type="date"
        value={formValues.expiresOn}
        onChange={(event) => {
          onFieldChange("expiresOn", event.target.value);
        }}
        error={Boolean(fieldErrors.expiresOn)}
        required
      />
      {fieldErrors.expiresOn ? (
        <Typography variant="caption" color="error">
          {fieldErrors.expiresOn}
        </Typography>
      ) : null}

      <TextField
        label="Prefix"
        name="codePrefix"
        type="text"
        value={formValues.codePrefix}
        onChange={(event) => {
          onFieldChange("codePrefix", event.target.value);
        }}
        placeholder="FRÜHLING"
        error={Boolean(fieldErrors.codePrefix)}
        required
      />
      <Typography variant="caption">
        Der Prefix ist der Anfang des Codes, z. B. &quot;FRÜHLING&quot;. Alle erstellten Codes erhalten im Anschluss
        eine zufallsgenerierte Zahlen- und Buchstabenkombination.
      </Typography>
      {fieldErrors.codePrefix ? (
        <Typography variant="caption" color="error">
          {fieldErrors.codePrefix}
        </Typography>
      ) : null}

      <Select
        label="Typ"
        name="type"
        value={formValues.type}
        onValueChange={(value) => {
          onFieldChange("type", value as PromoCodesCreateFormType["type"]);
        }}
        error={Boolean(fieldErrors.type)}
        fullWidth
      >
        {PROMO_CODE_TYPE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </Select>
      {fieldErrors.type ? (
        <Typography variant="caption" color="error">
          {fieldErrors.type}
        </Typography>
      ) : null}

      <TextField
        label="Anzahl der Monate"
        name="codeValue"
        type="number"
        value={formValues.codeValue}
        onChange={(event) => {
          onFieldChange("codeValue", Number(event.target.value));
        }}
        error={Boolean(fieldErrors.codeValue)}
        required
        min={1}
        max={12}
      />
      {fieldErrors.codeValue ? (
        <Typography variant="caption" color="error">
          {fieldErrors.codeValue}
        </Typography>
      ) : null}

      <LoadingButton type="submit" loading={loading} disabled={loading}>
        Promo-Codes erstellen
      </LoadingButton>
    </form>
  );
};

export default PromoCodesCreateForm;
